import { useState } from 'react';
import { Box } from '@mui/material';
import { AgingBucket, IAgingReceivables } from 'src/types';
import { useLocales } from 'src/locales';
import AgingBucketCards from './aging-bucket-cards';
import ClientAgingTable from './client-aging-table';
import ReceivablesBasisSplit from './receivables-basis-split';

type Props = {
  data: IAgingReceivables;
  /** Logging an activity changes status and last-contact on the row, so the report reloads. */
  onActivityLogged: () => void;
};

export default function ReceivablesSection({ data, onActivityLogged }: Props) {
  const { t } = useLocales('operativaDashboard');
  const [activeBucket, setActiveBucket] = useState<AgingBucket | null>(null);

  const handleBucketClick = (bucket: AgingBucket) => {
    setActiveBucket(activeBucket === bucket ? null : bucket);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
      }}
    >
      <AgingBucketCards
        buckets={data.buckets}
        activeBucket={activeBucket}
        onBucketClick={handleBucketClick}
      />
      <ReceivablesBasisSplit basisSplit={data.basisSplit} />
      <ClientAgingTable
        clients={data.clients}
        activeBucket={activeBucket}
        onActivityLogged={onActivityLogged}
        exportTitle={`${t('operativa')} – ${t('da_incassare')}`}
      />
    </Box>
  );
}
